import React from 'react'
import Hero from '../blog/blogShowCase/Hero'
import Footer from '../footer/Footer'
import Navbar from '../navbar/Navbar'
import ImmediateUnder from './immediateunder/ImmediateUnder'
import LatestStory from './latestStory/LatestStory'
import PictureArea from './pictureArea/PictureArea'

function Blog() {
    return (
        <div>
            <Navbar />
            <Hero />
            <LatestStory />
            <PictureArea />
            <ImmediateUnder /> 
            <Footer />
        </div>

    )
}

export default Blog
